import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ShareConnectionItemsMutationVariables = Types.Exact<{
  input: Types.ShareItemsInput;
}>;


export type ShareConnectionItemsMutation = { shareItems: { success?: boolean | null } };


export const ShareConnectionItemsDocument = /*#__PURE__*/ gql`
    mutation shareConnectionItems($input: ShareItemsInput!) {
  shareItems(input: $input) {
    success
  }
}
    `;

export function useShareConnectionItemsMutation() {
  return Urql.useMutation<ShareConnectionItemsMutation, ShareConnectionItemsMutationVariables>(ShareConnectionItemsDocument);
};